import { Select } from "antd";
import React, { memo } from "react";
import { DropdownArrowIcon } from "../mini/icons";
const { Option } = Select;

const sortBy = ({ currentValue, fields, onSelect, labelStyle = {} }) => {
  return (
    <>
      <Select
        // labelInValue
        defaultValue={currentValue}
        bordered={false}
        showArrow={false}
        onChange={onSelect}
        dropdownStyle={{ width: "100%" }}
        style={{
          padding: "0px 0px",
          color: "#333333",
          ...labelStyle,
          width: 140,
        }}
      >
        {fields.map((c) => (
          <Option key={c.key} value={c.key}>
            {c.name}
          </Option>
        ))}
      </Select>
      <DropdownArrowIcon styles={{ marginLeft: "-8px" }} />
    </>
  );
};

export default memo(sortBy);
